import PropTypes from 'prop-types';

export default {
    url: PropTypes.string,
    originalHTMLContent: PropTypes.string,
    bodyHTMLContent: PropTypes.string,
    title: PropTypes.string,
    subTitle: PropTypes.string,
}